module.exports = __webpack_public_path__ + "static/media/osvedceni-elektro.2697ed31.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/osvedceni-elektro.pdf
// module id = 379
// module chunks = 0